import { render, staticRenderFns } from "./SelectGameType.vue?vue&type=template&id=72225b00&scoped=true&lang=pug&"
import script from "./SelectGameType.vue?vue&type=script&lang=js&"
export * from "./SelectGameType.vue?vue&type=script&lang=js&"
import style0 from "./SelectGameType.vue?vue&type=style&index=0&id=72225b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72225b00",
  null
  
)

export default component.exports